<template>
  <div class="main">
    <div class="main-title">Select Brand</div>
    <el-row class="search">
      <el-col :span="8">
        <el-input
          size="small"
          placeholder="Search for brands"
          prefix-icon="el-icon-search"
          v-model="search"
          clearable
          :autofocus="true"
          @keyup.enter.native="requestFirstBrand"
        >
        </el-input>
      </el-col>
    </el-row>
    <div class="brands" ref="brandList">
      <div v-for="(brand, idx) in brands"
        :key="idx">
        <brand-card :logo-url="brand.logoUrl"
          :brand-slug="brand.slug"
          :name="brand.name"
          :is-partner="brand.hasConversionData">
        </brand-card>
      </div>
    </div>
    <div v-loading="this.state === 'loading'" class="loading"></div>
  </div>
</template>

<script>
  import ApiClient from './api-client.js'
  import BrandCard from '@/components/Card/BrandCard'
  import axios from 'axios'

  import { debounce } from 'lodash'

  export default {

    name: 'home',
    components: {
      BrandCard
    },
    data () {
      return {
        search: '',
        busy: true,
        nextUrl: null,
        state: 'loading',
        brands: [],
        cancelToken: null,
        goToFirstBrandRequested: false
      }
    },
    created () {
      this.$store.commit('setBrand', {})
      this.handleLoading()
      ApiClient.listBrands(null, 30)
        .then(
          response => {
            this.brands = response.data.results
            if (response.data.next) {
              const parsed_url = new URL(response.data.next)
              this.nextUrl = '/brands/' + parsed_url.search
            }
            if (this.brands.length === 1) {
              const brand = this.brands[0]
              this.$router.push({name: 'organize', params: {brandName: brand.slug}})
            }
            this.handleLoaded()
          }
        ).catch(() => {
          this.state = 'error'
        })
    },
    mounted () {
      document.addEventListener('scroll', this.onInfiniteScroll)
    },
    beforeDestroy () {
      document.removeEventListener('scroll', this.onInfiniteScroll)
    },
    methods: {
      onInfiniteScroll () {
        const bottomOfWindow = document.documentElement.scrollTop + window.innerHeight >= this.$refs.brandList.offsetHeight

        if (bottomOfWindow && !this.busy) {
          this.loadMore()
        }
      },
      loadMore () {
        if (this.nextUrl) {
          this.handleLoading()
          ApiClient.client.get(this.nextUrl)
            .then(response => {
              this.brands = this.brands.concat(response.data.results)
              if (response.data.next) {
                const parsed_url = new URL(response.data.next)
                this.nextUrl = '/brands/' + parsed_url.search
              } else {
                this.nextUrl = null
              }
              this.handleLoaded()
            })
        }
      },
      handleLoading () {
        this.busy = true
        this.state = 'loading'
      },
      handleLoaded () {
        this.busy = false
        this.state = 'loaded'
        if (this.goToFirstBrandRequested) {
          this.goToFirstBrand()
        }

        this.goToFirstBrandRequested = false
      },
      searchBrands: debounce(function () {
        this.handleLoading()
        if (this.cancelToken) {
          this.cancelToken.cancel()
          this.cancelToken = undefined
        }

        const CancelToken = axios.CancelToken
        const source = CancelToken.source()
        source.throwIfRequested = function () { // This is broken in axios so the function has to be set here
          if (this.reason) {
            throw this.reason
          }
        }
        this.cancelToken = source
        ApiClient.listBrands(this.search, 25, this.cancelToken)
          .then(response => {
            this.brands = response.data.results
            if (response.data.next) {
              const parsed_url = new URL(response.data.next)
              this.nextUrl = '/brands/' + parsed_url.search
            } else {
              this.nextUrl = null
            }
            this.handleLoaded()
          }).catch((error) => {
            if (axios.isCancel(error)) {
              // skip over axios cancels
            } else {
              this.$notify({
                title: 'Error',
                message: '',
                type: 'error'
              })
              this.error = 'Sorry! Something went wrong.'
              this.busy = false
              this.state = 'error'
            }
          })
      }, 200),
      goToFirstBrand () {
        if (this.brands.length) {
          this.$router.push({name: 'organize', params: {brandName: this.brands[0].slug}})
        }
      },
      requestFirstBrand () {
        if (this.state === 'loading') {
          this.goToFirstBrandRequested = true
        } else {
          this.goToFirstBrand()
        }
      }
    },
    watch: {
      search () {
        this.searchBrands()
      }
    }
  }
</script>

<style lang="less" scoped>
  .main {
    margin: 0 auto;
    padding-top: 20px;
    width: 1170px;
    height: 100%;
  }

  .main-title {
    font-size: 32px;
    font-weight: bold;
  }

  .brands {
    position: relative;
    left: 30px;
    width: 1200px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: flex-start;
    margin-left: -15px;
  }

  .search {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .loading {
    height: 100px;
  }

</style>
